import {
  NoticeItemEntity,
} from './noticeItemEntity';
import { Category } from './valueObjects/category';
import { CategoryId } from './valueObjects/categoryId';
import { CreateDatetime } from './valueObjects/createDatetime';
import { LastModifiedDatetime } from './valueObjects/lastModifiedDatetime';
import { MemberId } from './valueObjects/memberId';

import type {
  NoticeItemProps,
} from './noticeItemEntity';
import type { NoticeItemJson } from '@/types/domain/notice/entities/noticeItemEntity';

import { Factory } from '@/domain/factory';

/**
 * 掲示板アイテムのファクトリ
 */
export class NoticeItemFactory extends Factory<
  NoticeItemEntity,
  NoticeItemProps,
  NoticeItemJson
> {
  /**
   * 比較
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePvt = (a: NoticeItemJson, b: NoticeItemJson) => {
    const da = new Date(a.lastModifiedDatetime);
    const db = new Date(b.lastModifiedDatetime);
    return da < db ? 1 : -1;
  };

  /**
   * Entityを生成する
   * @param props プロパティ
   * @returns Entity
   */
  createPvt(props: NoticeItemProps): NoticeItemEntity {
    return new NoticeItemEntity(props, null);
  }

  /**
   * JsonからEntityを生成する
   * @param props Json
   * @returns Entity
   */
  createFromJsonPvt(props: NoticeItemJson): NoticeItemEntity {
    return this.createPvt({
      createDatetime: CreateDatetime.create(new Date(props.createDatetime)),
      createMemberId: MemberId.create(props.createMemberId),
      lastModifiedDatetime: LastModifiedDatetime.create(new Date(props.lastModifiedDatetime)),
      lastModifiedMemberId: MemberId.create(props.lastModifiedMemberId),
      categoryId: CategoryId.create(props.categoryId),
      title: Category.create(props.title),
    });
  }
}
